/* eslint-disable */
// Sidebar Routers 
export const menus = [
	{
		path: '/',
		name: 'message.home',
		icon: 'mdi-home',
		children: null,
	},
	{
		path: '/menu',
		name: 'message.menu',
		icon: 'mdi-food',
		children: null,
	},
	// {
	//    path: '/contact',
	//    name: "message.contactUs",
	//    icon: 'perm_contact_calendar',
	//    children: null
	// },
	{
		path: '/promociones',
		name: 'message.promotions',
		icon: 'mdi-fire',
		children: null,
	},
	{
		path: '/reservaciones',
		name: 'message.reservations',
		icon: 'mdi-calendar',
		children: null,
	},
	{
		path: '/locales',
		name: 'message.shops',
		icon: 'mdi-castle',
		children: null,
	},
];

export const adminPanelMenus = [
	{
		path: '/dashboard/reports',
		name: 'message.dashboard',
		icon: 'mdi-view-dashboard',
		children: null,
		active: true,
		permissions: 'see_dashboard',
	},
	{
		path: '',
		name: 'message.management',
		icon: 'mdi-file-document-box',
		active: false,
		permissions: [
			'salons_manage',
			'rooms_manage',
		],
		children: [
			{
				name: 'message.salons',
				path: '/dashboard/salons',
				permissions: 'salons_manage',
			},
			{
				name: 'message.shifts',
				path: '/dashboard/shifts',
				permissions: 'establishments_manage',
			},
			{
				name: 'message.rates',
				path: '/dashboard/rates',
				permissions: 'rooms_manage',
			},
			{
				name: 'message.rooms',
				path: '/dashboard/rooms',
				permissions: 'rooms_manage',
			},
			{
				name: 'message.roomTypes',
				path: '/dashboard/room-types',
				permissions: 'rooms_manage',
			},
		],
	},
	{
		path: '',
		name: 'message.products',
		icon: 'mdi-food',
		active: false,
		permissions: ['items_manage', 'categories_manage', 'unit_types_manage'],
		children: [
			{
				name: 'message.menu',
				path: '/dashboard/items',
				permissions: 'items_manage',
			},
			{
				name: 'message.categories',
				path: '/dashboard/categories',
				permissions: 'categories_manage',
			},
			{
				name: 'message.movements',
				path: '/dashboard/movements',
				permissions: 'to_do_transactions_in_warehouses',
			},
			{
				name: 'message.inventories',
				path: '/dashboard/inventories',
				permissions: 'see_inventory',
			},
			{
				name: 'message.unitTypes',
				path: '/dashboard/unit-types',
				permissions: 'unit_types_manage',
			},
		],
	},
	{
		path: '',
		name: 'message.lodgings',
		icon: 'mdi-lock-open',
		active: false,
		permissions: ['generate_rentals', 'customers_manage', 'see_rentals'],
		children: [
			{
				name: 'message.reception',
				path: '/dashboard/rent',
				permissions: 'generate_rentals',
			},
			// {
			// 	name: 'message.roomsInUse',
			// 	path: '/dashboard/rooms-in-use',
			// 	permissions: 'generate_rentals',
			// },
			{
				name: 'message.rentals',
				path: '/dashboard/rentals',
				permissions: 'see_rentals',
			},
			{
				name: 'message.customers',
				path: '/dashboard/people/customers',
				permissions: 'customers_manage',
			},
		],
	},
	{
		path: '',
		name: 'message.sales',
		icon: 'mdi-cart',
		active: false,
		permissions: [
			'generate_rentals',
			'generate_voucher',
			'see_vouchers',
			'generate_summaries',
			'voided_vouchers',
			'customers_manage',
		],
		children: [
			{
				name: 'message.documents',
				path: '/dashboard/documents',
				permissions: 'see_vouchers',
			},
			
			{
				name: 'message.debt',
				path: '/dashboard/debts',
				permissions: 'generate_voucher',
			},
			{
				name: 'message.summaries',
				path: '/dashboard/summaries',
				permissions: 'generate_summaries',
			},
			{
				name: 'message.voided',
				path: '/dashboard/voided',
				permissions: 'voided_vouchers',
			},
			
		],
	},
	{
		path: '',
		name: 'message.cash',
		icon: 'mdi-cash-multiple',
		active: false,
		permissions: ['to_do_transactions_in_cash', 'cash_manage'],
		children: [
			{
				name: 'message.openings',
				path: '/dashboard/openings',
				permissions: 'to_do_transactions_in_cash',
			},
			{
				name: 'message.cashManage',
				path: '/dashboard/cashes',
				permissions: 'cash_manage',
			},
			{
				name: 'message.openingsHistory',
				path: '/dashboard/openings-history',
				permissions: 'to_do_transactions_in_cash',
			},
		],
	},
	{
		path: '',
		name: 'message.reports',
		icon: 'mdi-chart-bar',
		active: false,
		permissions: ['see_report_of_sales'],
		children: [
			{
				name: 'message.documents',
				path: '/dashboard/report/documents',
				permissions: 'see_report_of_sales',
			},
			{
				name: 'message.rentals',
				path: '/dashboard/report/rentals',
				permissions: 'see_report_of_sales',
			},
			// {
			// 	name: 'message.sales',
			// 	path: '/dashboard/report/sales',
			// 	permissions: 'see_report_of_sales',
			// },
			{
				name: 'message.cleaningReport',
				path: '/dashboard/report/cleaning',
				permissions: 'see_report_of_sales',
			},
			{
				name: 'message.reasonTravel',
				path: '/dashboard/report/reasons-travel',
				permissions: 'see_report_of_sales',
			},
		],
	},
	{
		path: '',
		name: 'message.configurations',
		icon: 'mdi-settings',
		active: false,
		permissions: [
			'permissions_manage',
			'roles_manage',
			'users_manage',
			'tasks_manage',
			'establishments_manage',
			'configurations_manage',
		],
		children: [
			{
				name: 'message.usersManage',
				path: '',
				permissions: ['permissions_manage', 'roles_manage', 'users_manage'],
				children: [
					{
						path: '/dashboard/permissions',
						name: 'message.permissions',
						active: false,
						permissions: 'permissions_manage',
					},
					{
						path: '/dashboard/roles',
						name: 'message.roles',
						active: false,
						permissions: 'roles_manage',
					},
					{
						path: '/dashboard/users',
						name: 'message.users',
						active: false,
						permissions: 'users_manage',
					},
				],
			},
			{
				name: 'message.CleaningPersonnel',
				path: '/dashboard/cleaning-personnel',
				permissions: 'users_manage',
			},
			{
				name: 'message.tasks',
				path: '/dashboard/tasks',
				permissions: 'tasks_manage',
			},
			{
				name: 'message.establishments',
				path: '/dashboard/establishments',
				permissions: 'establishments_manage',
			},
			{
				name: 'message.correlatives',
				path: '/dashboard/correlatives',
				permissions: 'configurations_manage',
			},
			{
				name: 'message.settings',
				path: '/dashboard/configurations',
				permissions: 'configurations_manage',
			},
		],
	},
];
